import React, { createContext, useContext } from 'react';
import { useAtlassianContext } from '../hooks/useAtlassianContext';
import SectionMessage from '@atlaskit/section-message';

const AtlassianContext = createContext(null);

export function AtlassianContextProvider({ children }) {
  const { context, token, loading, isValidLicense, location } = useAtlassianContext();

  if (loading) return <div>Loading Atlassian context...</div>;

  if (!isValidLicense) {
    return (
      <SectionMessage
        title='Free trial not started or the trial period has expired'
        appearance='warning'
      />
    );
  }

  return (
    <AtlassianContext.Provider value={{ context: context, token: token, location: location }}>
      {children}
    </AtlassianContext.Provider>
  );
}

export function useAP() {
  const context = useContext(AtlassianContext);
  if (context === null) {
    throw new Error('useAP must be used within an AtlassianContextProvider');
  }
  return context;
}
